export var TrueType;
(function (TrueType) {
    TrueType["ARRAY"] = "array";
    TrueType["BOOLEAN"] = "boolean";
    TrueType["DATE"] = "date";
    TrueType["FUNCTION"] = "function";
    TrueType["NULL"] = "null";
    TrueType["NUMBER"] = "number";
    TrueType["OBJECT"] = "object";
    TrueType["REGEX"] = "regexp";
    TrueType["STRING"] = "string";
    TrueType["UNDEFINED"] = "undefined";
})(TrueType || (TrueType = {}));
